export function filterCells(event, column, orgaWithChart) {
    //hide the column quota when there is a session
    if (column.quota && event.use_sessions) {
        return false;
    }

    //Orga without chart
    if (!event && !column.seating) {
        return true;
    }

    //Orga with chart
    if (orgaWithChart) {
        return true;
    }

    //Event without chart
    if (!column.seating) {
        return true;
    }

    //Event with chart
    if (event?.isRealSeating() || event?.isFakeSeatingMultipleInventories()) {
        return true;
    }
    return false;
}

export function deleteRates({ rateClass, ratesToDelete = [], rates = [], onDone = () => {}, toastError = () => {}, organizationId, eventId = null }) {
    if (ratesToDelete.length > 1) {
        return rateClass
            .destroy(ratesToDelete, { organizationId, eventId: eventId })
            .then(() => {
                onDone();
            })
            .catch(e => {
                console.error(e);
                toastError();
            });
    }

    let rate = ratesToDelete[0];

    return rate
        .delete({
            organizationId,
            eventId: eventId ? eventId : null
        })
        .then(() => {
            //handle display_group
            let editedRates = [];
            let tmpRates = rates.filter(frate => frate.group === rate.group && frate.pk !== rate.pk);

            tmpRates.forEach(frate => {
                if (rate.display_order < frate.display_order) {
                    frate.display_order -= 1;
                    frate.translations = { name: {} };
                    editedRates.push(frate);
                }
            });
            rateClass
                .save(editedRates, {
                    organizationId,
                    eventId: eventId ? eventId : null
                })
                .then(() => {
                    onDone();
                });
        })
        .catch(e => {
            console.error(e);
            toastError();
        });
}

export function compute_sum_float(f1, f2) {
    // toFixed on IE have some bad behavior
    return Math.round((f1 + f2) * 1e12) / 1e12;
}
